import React from "react";

function Anker({ anker }: {anker?: string}) {
  return (
    <div id={anker} className="anker"></div>
  );
}

export default Anker;